webpackJsonp([264598414423048],{

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var content = _ref.content,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    content
	  );
	};
	
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref2) {
	  var content = _ref2.content,
	      className = _ref2.className;
	  return _react2.default.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: content } });
	};

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = exports.AboutPageTemplate = undefined;
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(244);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactIntl = __webpack_require__(23);
	
	var _Content = __webpack_require__(560);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _ContactForm = __webpack_require__(488);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPageTemplate = exports.AboutPageTemplate = (0, _reactIntl.injectIntl)(function (_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent,
	      helmet = _ref.helmet,
	      intl = _ref.intl;
	
	  var PageContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'section section-about-page section--gradient', id: 'us' },
	    helmet || '',
	    _react2.default.createElement(
	      'h2',
	      { className: 'title is-size-3 has-text-weight-bold is-bold-light' },
	      title
	    ),
	    _react2.default.createElement(PageContent, { className: 'content', content: content }),
	    _react2.default.createElement(_ContactForm2.default, {
	      topic: '[' + intl.locale.toUpperCase() + '] Contact - About Us'
	    })
	  );
	});
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	
	  //console.log('about', data)
	  var post = data.aboutPage;
	
	
	  return _react2.default.createElement(AboutPageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: post.frontmatter.title,
	    content: post.html,
	    helmet: _react2.default.createElement(_reactHelmet2.default, {
	      title: '' + post.frontmatter.title,
	      meta: [{ name: 'charset', content: 'UTF-8' }, { name: 'description', content: '' + post.frontmatter.description }, { name: 'keywords', content: '' + post.frontmatter.keywords }]
	    })
	  });
	};
	
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-page-js-07a7c9b953ce512156dd.js